export const PAYMENT_TRANSACTION_TYPES = {
    AUTHORIZE: 'authorize',
    CAPTURE: 'capture',
    CHARGE: 'charge',
    MANUAL: 'manual',
    MANUAL_REFUND: 'manual_refund',
    PARTIAL_REFUND: 'partial_refund',
    REFUNDED: 'refunded',
    REQUEST: 'request',
    CASH: 'cash',
    INVOICE: 'invoice',
    VOID: 'void',
} as const;

export type PaymentTransactionType = typeof PAYMENT_TRANSACTION_TYPES[keyof typeof PAYMENT_TRANSACTION_TYPES];

